// Bundled emoji list for the chat emoji popup (EmojiPicker.jsx).
// Generated from emojibase-data 18.0.0 (en/data.json), filtered to common
// groups, Emoji <= 14.0, no skin-tone or gendered variants. Not a package
// dependency: this file is the whole dataset. Row = [emoji, name, keywords].
const EMOJI_DATA = [
  ["😀","grinning face","cheerful cheery grin happy laugh nice smile"],
  ["😃","grinning face with big eyes","awesome grin happy mouth open smile smiling"],
  ["😄","grinning face with smiling eyes","eye grin happy laugh lol mouth open"],
  ["😁","beaming face with smiling eyes","eye grin grinning happy nice smile teeth"],
  ["😆","grinning squinting face","closed eyes haha hahaha happy laugh lol"],
  ["😅","grinning face with sweat","cold dejected excited mouth nervous open smile"],
  ["🤣","rolling on the floor laughing","crying face funny haha happy hehe hilarious"],
  ["😂","face with tears of joy","laugh lol lmao crying feels funny haha happy hehe hilarious"],
  ["🙂","slightly smiling face","happy smile"],
  ["🙃","upside-down face","hehe smile"],
  ["🫠","melting face","disappear dissolve embarrassed haha heat hot liquid"],
  ["😉","winking face","flirt heartbreaker sexy slide tease wink winks"],
  ["😊","smiling face with smiling eyes","blush eye glad satisfied smile"],
  ["😇","smiling face with halo","angel angelic angels blessed fairy fairytale fantasy"],
  ["🥰","smiling face with hearts","3 adore crush heart ily love romance"],
  ["😍","smiling face with heart-eyes","143 bae eye feels hearts ily kisses"],
  ["🤩","star-struck","excited eyes face grinning smile star starry-eyed"],
  ["😘","face blowing a kiss","adorbs bae flirt heart ily love lover"],
  ["😗","kissing face","143 date dating flirt ily kiss love"],
  ["☺️","smiling face","happy outlined relaxed smile"],
  ["😚","kissing face with closed eyes","143 bae blush date dating eye flirt"],
  ["😙","kissing face with smiling eyes","143 closed date dating eye flirt ily"],
  ["🥲","smiling face with tear","glad grateful happy joy pain proud relieved"],
  ["😋","face savoring food","delicious eat full hungry savor smile smiling"],
  ["😛","face with tongue","awesome cool nice party stuck-out sweet"],
  ["😜","winking face with tongue","crazy epic eye funny joke loopy nutty"],
  ["🤪","zany face","crazy eye eyes goofy large small"],
  ["😝","squinting face with tongue","closed eye eyes gross horrible omg stuck-out"],
  ["🤑","money-mouth face","money mouth paid"],
  ["🤗","smiling face with open hands","hug hugging"],
  ["🤭","face with hand over mouth","giggle giggling oops realization secret shock sudden"],
  ["🫢","face with open eyes and hand over mouth","amazement awe disbelief embarrass gasp omg quiet"],
  ["🫣","face with peeking eye","captivated embarrass hide hiding peek peep scared"],
  ["🤫","shushing face","quiet shh shush"],
  ["🤔","thinking face","chin consider hmm ponder pondering wondering"],
  ["🫡","saluting face","ok good luck ma'am respect salute sir"],
  ["🤐","zipper-mouth face","keep mouth quiet secret shut zip zipper"],
  ["🤨","face with raised eyebrow","disapproval disbelief distrust emoji hmm mild skeptic"],
  ["😐","neutral face","awkward blank deadpan expressionless fine jealous meh"],
  ["😑","expressionless face","awkward dead fine inexpressive jealous meh not"],
  ["😶","face without mouth","awkward blank expressionless mouthless mute quiet secret"],
  ["🫥","dotted line face","depressed disappear hidden hide introvert invisible meh"],
  ["😶‍🌫️","face in clouds","absentminded fog head"],
  ["😏","smirking face","boss dapper flirt homie kidding leer shade"],
  ["😒","unamused face","bored fine jealous jel jelly pissed smh"],
  ["🙄","face with rolling eyes","eyeroll shade ugh whatever"],
  ["😬","grimacing face","awk awkward dentist grimace grinning smile smiling"],
  ["😮‍💨","face exhaling","blow blowing exhale exhausted gasp groan relief"],
  ["🤥","lying face","liar lie pinocchio"],
  ["😌","relieved face","calm peace relief zen"],
  ["😔","pensive face","awful bored dejected died disappointed losing lost"],
  ["😪","sleepy face","crying good night sad sleep sleeping tired"],
  ["🤤","drooling face",""],
  ["😴","sleeping face","bed bedtime good goodnight nap night sleep"],
  ["😷","face with medical mask","cold dentist dermatologist doctor dr germs medicine"],
  ["🤒","face with thermometer","ill sick"],
  ["🤕","face with head-bandage","bandage hurt injury ouch"],
  ["🤢","nauseated face","gross nasty sick vomit"],
  ["🤮","face vomiting","barf ew gross puke sick spew throw"],
  ["🤧","sneezing face","fever flu gesundheit sick sneeze"],
  ["🥵","hot face","dying feverish heat panting red-faced stroke sweating"],
  ["🥶","cold face","blue blue-faced freezing frostbite icicles subzero teeth"],
  ["🥴","woozy face","dizzy drunk eyes intoxicated mouth tipsy uneven"],
  ["😵","face with crossed-out eyes","dead dizzy feels knocked out sick tired"],
  ["😵‍💫","face with spiral eyes","confused dizzy hypnotized omg smiley trouble whoa"],
  ["🤯","exploding head","blown explode mind mindblown no shocked way"],
  ["🤠","cowboy hat face","cowgirl"],
  ["🥳","partying face","bday birthday celebrate celebration excited happy hat"],
  ["🥸","disguised face","disguise eyebrow glasses incognito moustache mustache nose"],
  ["😎","smiling face with sunglasses","awesome beach bright bro chilling cool rad"],
  ["🤓","nerd face","brainy clever expert geek gifted glasses intelligent"],
  ["🧐","face with monocle","classy fancy rich stuffy wealthy"],
  ["😕","confused face","befuddled confusing dunno frown hm meh not"],
  ["🫤","face with diagonal mouth","confused confusion disappointed doubt doubtful frustrated frustration"],
  ["😟","worried face","anxious butterflies nerves nervous sad stress stressed"],
  ["🙁","slightly frowning face","frown sad"],
  ["☹️","frowning face","frown sad"],
  ["😮","face with open mouth","believe forgot omg shocked surprised sympathy unbelievable"],
  ["😯","hushed face","epic omg stunned surprised whoa woah"],
  ["😲","astonished face","cost no omg shocked totally way"],
  ["😳","flushed face","amazed awkward crazy dazed dead disbelief embarrassed"],
  ["🥺","pleading face","begging big eyes mercy not please pretty"],
  ["🥹","face holding back tears","admiration aww cry embarrassed feelings grateful gratitude"],
  ["😦","frowning face with open mouth","caught frown guard scared scary surprise what"],
  ["😧","anguished face","forgot scared scary stressed surprise unhappy what"],
  ["😨","fearful face","afraid anxious blame fear scared worried"],
  ["😰","anxious face with sweat","blue cold eek mouth nervous open rushed"],
  ["😥","sad but relieved face","anxious call close complicated disappointed not sweat"],
  ["😢","crying face","awful cry feels miss sad tear triste"],
  ["😭","loudly crying face","bawling cry sad sob tear tears unhappy"],
  ["😱","face screaming in fear","epic fearful munch scared scream screamer shocked"],
  ["😖","confounded face","annoyed confused cringe distraught feels frustrated mad"],
  ["😣","persevering face","concentrate concentration focus headache persevere"],
  ["😞","disappointed face","awful blame dejected fail losing sad unhappy"],
  ["😓","downcast face with sweat","close cold feels headache nervous sad scared"],
  ["😩","weary face","crying fail feels hungry mad nooo sad"],
  ["😫","tired face","cost feels nap sad sneeze"],
  ["🥱","yawning face","bedtime bored goodnight nap night sleep sleepy"],
  ["😤","face with steam from nose","anger angry feels fume fuming furious fury"],
  ["😡","enraged face","anger angry feels mad maddening pouting rage"],
  ["😠","angry face","anger blame feels frustrated mad maddening rage"],
  ["🤬","face with symbols on mouth","censor cursing cussing mad pissed swearing"],
  ["😈","smiling face with horns","demon devil evil fairy fairytale fantasy purple"],
  ["👿","angry face with horns","demon devil evil fairy fairytale fantasy imp"],
  ["💀","skull","dead lmao body dead death face fairy fairytale i'm"],
  ["☠️","skull and crossbones","bone dead death face monster"],
  ["💩","pile of poo","bs comic doo dung face fml monster"],
  ["🤡","clown face",""],
  ["👹","ogre","creature devil face fairy fairytale fantasy mask"],
  ["👺","goblin","angry creature face fairy fairytale fantasy mask"],
  ["👻","ghost","boo creature excited face fairy fairytale fantasy"],
  ["👽","alien","creature extraterrestrial face fairy fairytale fantasy monster"],
  ["👾","alien monster","creature extraterrestrial face fairy fairytale fantasy game"],
  ["🤖","robot","face monster"],
  ["😺","grinning cat","animal face mouth open smile smiling"],
  ["😸","grinning cat with smiling eyes","animal eye face grin smile"],
  ["😹","cat with tears of joy","animal face laugh laughing lol tear"],
  ["😻","smiling cat with heart-eyes","animal eye face heart love smile"],
  ["😼","cat with wry smile","animal face ironic"],
  ["😽","kissing cat","animal closed eye eyes face kiss"],
  ["🙀","weary cat","animal face oh surprised"],
  ["😿","crying cat","animal cry face sad tear"],
  ["😾","pouting cat","animal face"],
  ["🙈","see-no-evil monkey","embarrassed evil face forbidden forgot gesture hide"],
  ["🙉","hear-no-evil monkey","animal ears evil face forbidden gesture hear"],
  ["🙊","speak-no-evil monkey","animal evil face forbidden gesture no not"],
  ["💌","love letter","heart mail romance valentine"],
  ["💘","heart with arrow","143 adorbs cupid date emotion ily love"],
  ["💝","heart with ribbon","143 anniversary emotion ily kisses valentine xoxo"],
  ["💖","sparkling heart","143 emotion excited good ily kisses morning"],
  ["💗","growing heart","143 emotion excited heartpulse ily kisses muah"],
  ["💓","beating heart","143 cardio emotion heartbeat ily love pulsating"],
  ["💞","revolving hearts","143 adorbs anniversary emotion heart"],
  ["💕","two hearts","143 anniversary date dating emotion heart ily"],
  ["💟","heart decoration","143 emotion hearth purple white"],
  ["❣️","heart exclamation","bang heavy mark punctuation"],
  ["💔","broken heart","break crushed emotion heartbroken lonely sad"],
  ["❤️‍🔥","heart on fire","burn love lust sacred"],
  ["❤️‍🩹","mending heart","healthier improving recovering recuperating well"],
  ["❤️","red heart","emotion love"],
  ["🧡","orange heart","143"],
  ["💛","yellow heart","143 cardiac emotion ily love"],
  ["💚","green heart","143 emotion ily love romantic"],
  ["💙","blue heart","143 emotion ily love romance"],
  ["💜","purple heart","143 bestest emotion ily love"],
  ["🤎","brown heart","143"],
  ["🖤","black heart","evil wicked"],
  ["🤍","white heart","143"],
  ["💋","kiss mark","dating emotion heart kissing lips romance sexy"],
  ["💯","hundred points","100 true agree clearly definitely faithful fleek"],
  ["💢","anger symbol","angry comic mad upset"],
  ["💥","collision","bomb boom collide comic explode"],
  ["💫","dizzy","comic shining shooting star stars"],
  ["💦","sweat droplets","comic drip droplet drops splashing squirt water"],
  ["💨","dashing away","cloud comic dash fart fast go gone"],
  ["🕳️","hole",""],
  ["💬","speech balloon","bubble comic dialog message sms talk text"],
  ["👁️‍🗨️","eye in speech bubble","balloon witness"],
  ["🗨️","left speech bubble","balloon dialog"],
  ["🗯️","right anger bubble","angry balloon mad"],
  ["💭","thought balloon","bubble cartoon cloud comic daydream decisions dream"],
  ["💤","zzz","comic good goodnight night sleep sleeping sleepy"],
  ["👋","waving hand","bye cya g2g greetings gtg hello hey"],
  ["🤚","raised back of hand","backhand"],
  ["🖐️","hand with fingers splayed","finger raised stop"],
  ["✋","raised hand","5 five high stop"],
  ["🖖","vulcan salute","finger hand hands"],
  ["🫱","rightwards hand","handshake hold reach right rightward shake"],
  ["🫲","leftwards hand","handshake hold left leftward reach shake"],
  ["🫳","palm down hand","dismiss drop dropped pick shoo up"],
  ["🫴","palm up hand","beckon catch come hold know lift me"],
  ["👌","ok hand","awesome bet dope fleek fosho got gotcha"],
  ["🤌","pinched fingers","gesture hand hold huh interrogation patience relax"],
  ["🤏","pinching hand","amount bit fingers little small sort"],
  ["✌️","victory hand","peace v"],
  ["🤞","crossed fingers","cross finger hand luck"],
  ["🫰","hand with index finger and thumb crossed","expensive heart love money snap"],
  ["🤟","love-you gesture","ily fingers hand love three you"],
  ["🤘","sign of the horns","finger hand rock-on"],
  ["🤙","call me hand","shaka hang loose"],
  ["👈","backhand index pointing left","finger hand point"],
  ["👉","backhand index pointing right","finger hand point"],
  ["👆","backhand index pointing up","finger hand point"],
  ["🖕","middle finger","hand"],
  ["👇","backhand index pointing down","finger hand point"],
  ["☝️","index pointing up","finger hand point this"],
  ["🫵","index pointing at the viewer","finger hand poke you"],
  ["👍","thumbs up","good hand like thumb yes"],
  ["👎","thumbs down","-1 bad dislike good hand no nope"],
  ["✊","raised fist","clenched hand punch solidarity"],
  ["👊","oncoming fist","absolutely agree boom bro bruh bump clenched"],
  ["🤛","left-facing fist","leftwards"],
  ["🤜","right-facing fist","rightwards"],
  ["👏","clapping hands","applause approval awesome clap congrats congratulations excited"],
  ["🙌","raising hands","celebration gesture hand hooray praise raised"],
  ["🫶","heart hands","love you"],
  ["👐","open hands","hand hug jazz swerve"],
  ["🤲","palms up together","cupped dua hands pray prayer wish"],
  ["🤝","handshake","agreement deal hand meeting shake"],
  ["🙏","folded hands","appreciate ask beg blessed bow cmon five"],
  ["✍️","writing hand","write"],
  ["💅","nail polish","bored care cosmetics done makeup manicure whatever"],
  ["🤳","selfie","camera phone"],
  ["💪","flexed biceps","arm beast bench bodybuilder bro curls flex"],
  ["🦾","mechanical arm","accessibility prosthetic"],
  ["🦿","mechanical leg","accessibility prosthetic"],
  ["🦵","leg","bent foot kick knee limb"],
  ["🦶","foot","ankle feet kick stomp"],
  ["👂","ear","body ears hear hearing listen listening sound"],
  ["🦻","ear with hearing aid","accessibility hard"],
  ["👃","nose","body noses nosey odor smell smells"],
  ["🧠","brain","intelligent smart"],
  ["🫀","anatomical heart","beat cardiology heartbeat organ pulse real red"],
  ["🫁","lungs","breath breathe exhalation inhalation lung organ respiration"],
  ["🦷","tooth","dentist pearly teeth white"],
  ["🦴","bone","bones dog skeleton wishbone"],
  ["👀","eyes","body eye face googly look looking omg"],
  ["👁️","eye","1 body one"],
  ["👅","tongue","body lick slurp"],
  ["👄","mouth","beauty body kiss kissing lips lipstick"],
  ["🫦","biting lip","anxious bite fear flirt flirting kiss lipstick"],
  ["🙍","person frowning","annoyed disappointed disgruntled disturbed frown frustrated gesture"],
  ["🙎","person pouting","disappointed downtrodden frown grimace scowl sulk upset"],
  ["🙅","person gesturing no","forbidden gesture hand not prohibit"],
  ["🙆","person gesturing ok","exercise gesture hand omg"],
  ["💁","person tipping hand","fetch flick flip gossip sarcasm sarcastic sassy"],
  ["🙋","person raising hand","gesture here know me pick question raise"],
  ["🧏","deaf person","accessibility ear gesture hear"],
  ["🧏‍♂️","deaf man","accessibility ear gesture hear"],
  ["🧏‍♀️","deaf woman","accessibility ear gesture hear"],
  ["🙇","person bowing","apology ask beg bow favor forgive gesture"],
  ["🤦","person facepalming","again bewilder disbelief exasperation facepalm no not"],
  ["🤷","person shrugging","doubt dunno guess idk ignorance indifference knows"],
  ["🐵","monkey face","animal banana"],
  ["🐒","monkey","animal banana"],
  ["🦍","gorilla","animal"],
  ["🦧","orangutan","animal ape monkey"],
  ["🐶","dog face","adorbs animal pet puppies puppy"],
  ["🐕","dog","animal animals dogs pet"],
  ["🦮","guide dog","accessibility animal blind"],
  ["🐕‍🦺","service dog","accessibility animal assistance"],
  ["🐩","poodle","animal dog fluffy"],
  ["🐺","wolf","animal face"],
  ["🦊","fox","animal face"],
  ["🦝","raccoon","animal curious sly"],
  ["🐱","cat face","animal kitten kitty pet"],
  ["🐈","cat","animal animals cats kitten pet"],
  ["🐈‍⬛","black cat","animal feline halloween meow unlucky"],
  ["🦁","lion","leo alpha animal face mane order rawr"],
  ["🐯","tiger face","animal big cat predator"],
  ["🐅","tiger","animal big cat predator zoo"],
  ["🐆","leopard","animal big cat predator zoo"],
  ["🐴","horse face","animal dressage equine farm horses"],
  ["🐎","horse","animal equestrian farm racehorse racing"],
  ["🦄","unicorn","face"],
  ["🦓","zebra","animal stripe"],
  ["🦌","deer","animal"],
  ["🦬","bison","animal buffalo herd wisent"],
  ["🐮","cow face","animal farm milk moo"],
  ["🐂","ox","bull bullish taurus animal animals bull farm zodiac"],
  ["🐃","water buffalo","animal zoo"],
  ["🐄","cow","animal animals farm milk moo"],
  ["🐷","pig face","animal bacon farm pork"],
  ["🐖","pig","animal bacon farm pork sow"],
  ["🐗","boar","animal pig"],
  ["🐽","pig nose","animal face farm smell snout"],
  ["🐏","ram","aries animal horns male sheep zodiac zoo"],
  ["🐑","ewe","animal baa farm female fluffy lamb sheep"],
  ["🐐","goat","capricorn animal farm milk zodiac"],
  ["🐪","camel","animal desert dromedary hump one"],
  ["🐫","two-hump camel","animal bactrian desert hump two"],
  ["🦙","llama","alpaca animal guanaco wool"],
  ["🦒","giraffe","animal spots"],
  ["🐘","elephant","animal"],
  ["🦣","mammoth","animal extinction large tusk wooly"],
  ["🦏","rhinoceros","animal"],
  ["🦛","hippopotamus","animal hippo"],
  ["🐭","mouse face","animal"],
  ["🐁","mouse","animal animals"],
  ["🐀","rat","animal"],
  ["🐹","hamster","animal face pet"],
  ["🐰","rabbit face","animal bunny pet"],
  ["🐇","rabbit","animal bunny pet"],
  ["🐿️","chipmunk","animal squirrel"],
  ["🦫","beaver","animal dam teeth"],
  ["🦔","hedgehog","animal spiny"],
  ["🦇","bat","animal vampire"],
  ["🐻","bear","bear bearish animal face grizzly growl honey"],
  ["🐻‍❄️","polar bear","animal arctic white"],
  ["🐨","koala","animal australia bear down face marsupial under"],
  ["🐼","panda","animal bamboo face"],
  ["🦥","sloth","lazy slow"],
  ["🦦","otter","animal fishing playful"],
  ["🦨","skunk","animal stink"],
  ["🦘","kangaroo","animal joey jump marsupial"],
  ["🦡","badger","animal honey pester"],
  ["🐾","paw prints","feet paws print"],
  ["🦃","turkey","bird gobble thanksgiving"],
  ["🐔","chicken","animal bird ornithology"],
  ["🐓","rooster","animal bird ornithology"],
  ["🐣","hatching chick","animal baby bird egg"],
  ["🐤","baby chick","animal bird ornithology"],
  ["🐥","front-facing baby chick","animal bird newborn ornithology"],
  ["🐦","bird","animal ornithology"],
  ["🐧","penguin","animal antarctica bird ornithology"],
  ["🕊️","dove","bird fly ornithology peace"],
  ["🦅","eagle","animal bird ornithology"],
  ["🦆","duck","animal bird ornithology"],
  ["🦢","swan","animal bird cygnet duckling ornithology ugly"],
  ["🦉","owl","animal bird ornithology wise"],
  ["🦤","dodo","animal bird extinction large ornithology"],
  ["🪶","feather","bird flight light plumage"],
  ["🦩","flamingo","animal bird flamboyant ornithology tropical"],
  ["🦚","peacock","animal bird colorful ornithology ostentatious peahen pretty"],
  ["🦜","parrot","animal bird ornithology pirate talk"],
  ["🐸","frog","animal face"],
  ["🐊","crocodile","animal zoo"],
  ["🐢","turtle","animal terrapin tortoise"],
  ["🦎","lizard","animal reptile"],
  ["🐍","snake","ophiuchus animal bearer serpent zodiac"],
  ["🐲","dragon face","animal fairy fairytale tale"],
  ["🐉","dragon","animal fairy fairytale knights tale"],
  ["🦕","sauropod","brachiosaurus brontosaurus dinosaur diplodocus"],
  ["🦖","t-rex","rex t tyrannosaurus dinosaur"],
  ["🐳","spouting whale","animal beach face ocean"],
  ["🐋","whale","animal beach ocean"],
  ["🐬","dolphin","animal beach flipper ocean"],
  ["🦭","seal","animal lion ocean sea"],
  ["🐟","fish","pisces animal dinner fishes fishing zodiac"],
  ["🐠","tropical fish","animal fishes"],
  ["🐡","blowfish","animal fish"],
  ["🦈","shark","animal fish"],
  ["🐙","octopus","animal creature ocean"],
  ["🐚","spiral shell","animal beach conch sea"],
  ["🪸","coral","change climate ocean reef sea"],
  ["🦀","crab","cancer zodiac"],
  ["🦞","lobster","animal bisque claws seafood"],
  ["🦐","shrimp","food shellfish small"],
  ["🦑","squid","animal food mollusk"],
  ["🦪","oyster","diving pearl"],
  ["🐌","snail","animal escargot garden nature slug"],
  ["🦋","butterfly","insect pretty"],
  ["🐛","bug","animal garden insect"],
  ["🐜","ant","animal garden insect"],
  ["🐝","honeybee","animal bee bumblebee honey insect nature spring"],
  ["🪲","beetle","animal bug insect"],
  ["🐞","lady beetle","animal garden insect ladybird ladybug nature"],
  ["🦗","cricket","orthoptera animal bug grasshopper insect"],
  ["🪳","cockroach","animal insect pest roach"],
  ["🕷️","spider","animal insect"],
  ["🕸️","spider web",""],
  ["🦂","scorpion","scorpio scorpius zodiac"],
  ["🦟","mosquito","bite disease fever insect malaria pest virus"],
  ["🪰","fly","animal disease insect maggot pest rotting"],
  ["🪱","worm","animal annelid earthworm parasite"],
  ["🦠","microbe","amoeba bacteria science virus"],
  ["💐","bouquet","anniversary birthday date flower love plant romance"],
  ["🌸","cherry blossom","flower plant spring springtime"],
  ["💮","white flower",""],
  ["🪷","lotus","buddhism hinduism beauty calm flower peace purity"],
  ["🏵️","rosette","plant"],
  ["🌹","rose","beauty elegant flower love plant red valentine"],
  ["🥀","wilted flower","dying"],
  ["🌺","hibiscus","flower plant"],
  ["🌻","sunflower","flower outdoors plant sun"],
  ["🌼","blossom","buttercup dandelion flower plant"],
  ["🌷","tulip","blossom flower growth plant"],
  ["🌱","seedling","plant sapling sprout young"],
  ["🪴","potted plant","decor grow house nurturing pot"],
  ["🌲","evergreen tree","christmas forest pine"],
  ["🌳","deciduous tree","forest green habitat shedding"],
  ["🌴","palm tree","beach plant tropical"],
  ["🌵","cactus","desert drought nature plant"],
  ["🌾","sheaf of rice","ear grain grains plant"],
  ["🌿","herb","leaf plant"],
  ["☘️","shamrock","irish plant"],
  ["🍀","four leaf clover","4 four-leaf irish lucky plant"],
  ["🍁","maple leaf","falling"],
  ["🍂","fallen leaf","autumn fall falling"],
  ["🍃","leaf fluttering in wind","blow flutter"],
  ["🪹","empty nest","branch home nesting"],
  ["🪺","nest with eggs","bird branch egg nesting"],
  ["🍄","mushroom","fungus toadstool"],
  ["🍇","grapes","dionysus fruit grape"],
  ["🍈","melon","cantaloupe fruit"],
  ["🍉","watermelon","fruit"],
  ["🍊","tangerine","c citrus fruit nectarine orange vitamin"],
  ["🍋","lemon","citrus fruit sour"],
  ["🍌","banana","fruit potassium"],
  ["🍍","pineapple","colada fruit pina tropical"],
  ["🥭","mango","food fruit tropical"],
  ["🍎","red apple","diet food fruit health ripe"],
  ["🍏","green apple","fruit"],
  ["🍐","pear","fruit"],
  ["🍑","peach","fruit"],
  ["🍒","cherries","berries cherry fruit red"],
  ["🍓","strawberry","berry fruit"],
  ["🫐","blueberries","berries berry bilberry blue blueberry food fruit"],
  ["🥝","kiwi fruit","food"],
  ["🍅","tomato","food fruit vegetable"],
  ["🫒","olive","food"],
  ["🥥","coconut","colada palm"],
  ["🥑","avocado","food fruit"],
  ["🍆","eggplant","aubergine vegetable"],
  ["🥔","potato","food vegetable"],
  ["🥕","carrot","food vegetable"],
  ["🌽","ear of corn","crops farm maize maze"],
  ["🌶️","hot pepper",""],
  ["🫑","bell pepper","capsicum food vegetable"],
  ["🥒","cucumber","food pickle vegetable"],
  ["🥬","leafy green","bok burgers cabbage choy kale lettuce salad"],
  ["🥦","broccoli","cabbage wild"],
  ["🧄","garlic","flavoring"],
  ["🧅","onion","flavoring"],
  ["🥜","peanuts","food nut peanut vegetable"],
  ["🫘","beans","food kidney legume small"],
  ["🌰","chestnut","almond plant"],
  ["🍞","bread","carbs food grain loaf restaurant toast wheat"],
  ["🥐","croissant","bread breakfast crescent food french roll"],
  ["🥖","baguette bread","food french"],
  ["🫓","flatbread","arepa bread food gordita lavash naan pita"],
  ["🥨","pretzel","convoluted twisted"],
  ["🥯","bagel","bakery bread breakfast schmear"],
  ["🥞","pancakes","breakfast food hotcake pancake"],
  ["🧇","waffle","breakfast indecisive iron"],
  ["🧀","cheese wedge",""],
  ["🍖","meat on bone",""],
  ["🍗","poultry leg","bone chicken drumstick hungry turkey"],
  ["🥩","cut of meat","chop lambchop porkchop red steak"],
  ["🥓","bacon","breakfast food meat"],
  ["🍔","hamburger","burger eat fast food hungry"],
  ["🍟","french fries","fast food"],
  ["🍕","pizza","cheese food hungry pepperoni slice"],
  ["🌭","hot dog","frankfurter hotdog sausage"],
  ["🥪","sandwich","bread"],
  ["🌮","taco","mexican"],
  ["🌯","burrito","mexican wrap"],
  ["🫔","tamale","food mexican pamonha wrapped"],
  ["🥙","stuffed flatbread","falafel food gyro kebab"],
  ["🧆","falafel","chickpea meatball"],
  ["🥚","egg","breakfast food"],
  ["🍳","cooking","breakfast easy egg fry frying over pan"],
  ["🥘","shallow pan of food","casserole paella"],
  ["🍲","pot of food","soup stew"],
  ["🫕","fondue","cheese chocolate food melted pot ski"],
  ["🥣","bowl with spoon","breakfast cereal congee oatmeal porridge"],
  ["🥗","green salad","food"],
  ["🍿","popcorn","corn movie pop"],
  ["🧈","butter","dairy"],
  ["🧂","salt","condiment flavor mad salty shaker taste upset"],
  ["🥫","canned food","can"],
  ["🍱","bento box","food"],
  ["🍘","rice cracker","food"],
  ["🍙","rice ball","japanese food"],
  ["🍚","cooked rice","food"],
  ["🍛","curry rice","food"],
  ["🍜","steaming bowl","chopsticks food noodle pho ramen soup"],
  ["🍝","spaghetti","food meatballs pasta restaurant"],
  ["🍠","roasted sweet potato","food"],
  ["🍢","oden","food kebab restaurant seafood skewer stick"],
  ["🍣","sushi","food"],
  ["🍤","fried shrimp","prawn tempura"],
  ["🍥","fish cake with swirl","food pastry restaurant"],
  ["🥮","moon cake","autumn festival"],
  ["🍡","dango","japanese dessert skewer stick sweet"],
  ["🥟","dumpling","empanada jiaozi pierogi potsticker"],
  ["🥠","fortune cookie","prophecy"],
  ["🥡","takeout box","chopsticks delivery food oyster pail"],
  ["🍦","soft ice cream","dessert food icecream restaurant serve sweet"],
  ["🍧","shaved ice","dessert restaurant sweet"],
  ["🍨","ice cream","dessert food restaurant sweet"],
  ["🍩","doughnut","breakfast dessert donut food sweet"],
  ["🍪","cookie","chip chocolate dessert sweet"],
  ["🎂","birthday cake","bday celebration dessert happy pastry sweet"],
  ["🍰","shortcake","cake dessert pastry slice sweet"],
  ["🧁","cupcake","bakery dessert sprinkles sugar sweet treat"],
  ["🥧","pie","apple filling fruit meat pastry pumpkin slice"],
  ["🍫","chocolate bar","candy dessert halloween sweet tooth"],
  ["🍬","candy","cavities dessert halloween restaurant sweet tooth wrapper"],
  ["🍭","lollipop","candy dessert food restaurant sweet"],
  ["🍮","custard","dessert pudding sweet"],
  ["🍯","honey pot","barrel bear food honeypot jar sweet"],
  ["🍼","baby bottle","babies birth born drink infant milk newborn"],
  ["🥛","glass of milk","drink"],
  ["☕","hot beverage","cafe caffeine chai coffee drink morning steaming"],
  ["🫖","teapot","brew drink food pot tea"],
  ["🍵","teacup without handle","beverage cup drink oolong tea"],
  ["🍶","sake","bar beverage bottle cup drink restaurant"],
  ["🍾","bottle with popping cork","bar drink"],
  ["🍷","wine glass","alcohol bar beverage booze club drink drinking"],
  ["🍸","cocktail glass","alcohol bar booze club drink drinking drinks"],
  ["🍹","tropical drink","alcohol bar booze club cocktail drinking drinks"],
  ["🍺","beer mug","alcohol ale bar booze drink drinking drinks"],
  ["🍻","clinking beer mugs","alcohol bar booze bottoms cheers clink drinking"],
  ["🥂","clinking glasses","celebrate clink drink glass"],
  ["🥃","tumbler glass","liquor scotch shot whiskey whisky"],
  ["🫗","pouring liquid","accident drink empty glass oops pour spill"],
  ["🥤","cup with straw","drink juice malt soda soft water"],
  ["🧋","bubble tea","boba food milk pearl"],
  ["🧃","beverage box","juice straw sweet"],
  ["🧉","mate","drink"],
  ["🧊","ice","cold cube iceberg"],
  ["🥢","chopsticks","hashi jeotgarak kuaizi"],
  ["🍽️","fork and knife with plate","cooking dinner eat"],
  ["🍴","fork and knife","breakfast breaky cooking cutlery delicious dinner eat"],
  ["🥄","spoon","eat tableware"],
  ["🔪","kitchen knife","chef cooking hocho tool weapon"],
  ["🫙","jar","condiment container empty nothing sauce store"],
  ["🏺","amphora","aquarius cooking drink jug tool weapon zodiac"],
  ["✈️","airplane","aeroplane fly flying jet plane travel"],
  ["🛩️","small airplane","aeroplane plane"],
  ["🛫","airplane departure","aeroplane check-in departures plane"],
  ["🛬","airplane arrival","aeroplane arrivals arriving landing plane"],
  ["🪂","parachute","hang-glide parasail skydive"],
  ["💺","seat","chair"],
  ["🚁","helicopter","copter roflcopter travel vehicle"],
  ["🚟","suspension railway",""],
  ["🚠","mountain cableway","cable gondola lift ski"],
  ["🚡","aerial tramway","cable car gondola ropeway"],
  ["🛰️","satellite","space"],
  ["🚀","rocket","moon pump launch rockets space travel"],
  ["🛸","flying saucer","ufo aliens extra terrestrial"],
  ["🌑","new moon","dark space"],
  ["🌒","waxing crescent moon","dreams space"],
  ["🌓","first quarter moon","space"],
  ["🌔","waxing gibbous moon","space"],
  ["🌕","full moon","space"],
  ["🌖","waning gibbous moon","space"],
  ["🌗","last quarter moon","space"],
  ["🌘","waning crescent moon","space"],
  ["🌙","crescent moon","ramadan space"],
  ["🌚","new moon face","space"],
  ["🌛","first quarter moon face","space"],
  ["🌜","last quarter moon face","dreams"],
  ["🌡️","thermometer","weather"],
  ["☀️","sun","bright rays space sunny weather"],
  ["🌝","full moon face","bright"],
  ["🌞","sun with face","beach bright day heat shine sunny sunshine"],
  ["🪐","ringed planet","saturn saturnine"],
  ["⭐","star","astronomy medium stars white"],
  ["🌟","glowing star","glittery glow night shining sparkle win"],
  ["🌠","shooting star","falling night space"],
  ["🌌","milky way","space"],
  ["☁️","cloud","weather"],
  ["⛅","sun behind cloud","cloudy weather"],
  ["⛈️","cloud with lightning and rain","thunder thunderstorm"],
  ["🌤️","sun behind small cloud","weather"],
  ["🌥️","sun behind large cloud","weather"],
  ["🌦️","sun behind rain cloud","weather"],
  ["🌧️","cloud with rain","weather"],
  ["🌨️","cloud with snow","cold weather"],
  ["🌩️","cloud with lightning","weather"],
  ["🌪️","tornado","cloud weather whirlwind"],
  ["🌫️","fog","cloud weather"],
  ["🌬️","wind face","blow cloud"],
  ["🌀","cyclone","dizzy hurricane twister typhoon weather"],
  ["🌈","rainbow","gay genderqueer glbt glbtq lesbian lgbt lgbtq"],
  ["🌂","closed umbrella","clothing rain"],
  ["☂️","umbrella","clothing rain"],
  ["☔","umbrella with rain drops","clothing drop weather"],
  ["⛱️","umbrella on ground","rain sun"],
  ["⚡","high voltage","danger electric electricity lightning nature thunder thunderbolt"],
  ["❄️","snowflake","cold snow weather"],
  ["☃️","snowman","cold man snow"],
  ["⛄","snowman without snow","cold man"],
  ["☄️","comet","space"],
  ["🔥","fire","lit hot af burn flame hot lit litaf tool"],
  ["💧","droplet","cold comic drop nature sad sweat tear"],
  ["🌊","water wave","nature ocean surf surfer surfing"],
  ["🎃","jack-o-lantern","celebration halloween jack lantern pumpkin"],
  ["🎄","christmas tree","celebration"],
  ["🎆","fireworks","boom celebration entertainment yolo"],
  ["🎇","sparkler","boom celebration fireworks sparkle"],
  ["🧨","firecracker","dynamite explosive fire fireworks light pop popping"],
  ["✨","sparkles","magic sparkle star"],
  ["🎈","balloon","birthday celebrate celebration"],
  ["🎉","party popper","awesome birthday celebrate celebration excited hooray tada"],
  ["🎊","confetti ball","celebrate celebration party woohoo"],
  ["🎋","tanabata tree","japanese banner celebration"],
  ["🎍","pine decoration","japanese bamboo celebration plant"],
  ["🎎","japanese dolls","celebration doll festival"],
  ["🎏","carp streamer","celebration"],
  ["🎐","wind chime","bell celebration"],
  ["🎑","moon viewing ceremony","celebration"],
  ["🧧","red envelope","gift good lai luck money see"],
  ["🎀","ribbon","celebration"],
  ["🎁","wrapped gift","birthday bow box celebration christmas present surprise"],
  ["🎗️","reminder ribbon","celebration"],
  ["🎟️","admission tickets","ticket"],
  ["🎫","ticket","admission stub"],
  ["🎖️","military medal","award celebration"],
  ["🏆","trophy","champion champs prize slay sport victory win"],
  ["🏅","sports medal","award gold winner"],
  ["🥇","1st place medal","first gold"],
  ["🥈","2nd place medal","second silver"],
  ["🥉","3rd place medal","bronze third"],
  ["⚽","soccer ball","football futbol sport"],
  ["⚾","baseball","ball sport"],
  ["🥎","softball","ball glove sports underarm"],
  ["🏀","basketball","ball hoop sport"],
  ["🏐","volleyball","ball game"],
  ["🏈","american football","ball bowl sport super"],
  ["🏉","rugby football","ball sport"],
  ["🎾","tennis","ball racquet sport"],
  ["🥏","flying disc","ultimate"],
  ["🎳","bowling","ball game sport strike"],
  ["🏏","cricket game","ball bat"],
  ["🏑","field hockey","ball game stick"],
  ["🏒","ice hockey","game puck stick"],
  ["🥍","lacrosse","ball goal sports stick"],
  ["🏓","ping pong","ball bat game paddle pingpong table tennis"],
  ["🏸","badminton","birdie game racquet shuttlecock"],
  ["🥊","boxing glove",""],
  ["🥋","martial arts uniform","judo karate taekwondo"],
  ["🥅","goal net",""],
  ["⛳","flag in hole","golf sport"],
  ["⛸️","ice skate","skating"],
  ["🎣","fishing pole","entertainment fish sport"],
  ["🤿","diving mask","scuba snorkeling"],
  ["🎽","running shirt","athletics sash"],
  ["🎿","skis","ski snow sport"],
  ["🛷","sled","luge sledge sleigh snow toboggan"],
  ["🥌","curling stone","game rock"],
  ["🎯","bullseye","bull dart direct entertainment game hit target"],
  ["🪀","yo-yo","fluctuate toy"],
  ["🪁","kite","fly soar"],
  ["🔫","water pistol","gun handgun revolver tool weapon"],
  ["🎱","pool 8 ball","8ball billiard eight game"],
  ["🔮","crystal ball","fairy fairytale fantasy fortune future magic tale"],
  ["🪄","magic wand","magician witch wizard"],
  ["🎮","video game","controller entertainment"],
  ["🕹️","joystick","game video videogame"],
  ["🎰","slot machine","casino gamble gambling game slots"],
  ["🎲","game die","dice entertainment"],
  ["🧩","puzzle piece","clue interlocking jigsaw"],
  ["🧸","teddy bear","plaything plush stuffed toy"],
  ["🪅","pi ata","candy celebrate celebration cinco de festive mayo"],
  ["🪩","mirror ball","dance disco glitter party"],
  ["🪆","nesting dolls","babooshka baboushka babushka doll matryoshka russia"],
  ["♠️","spade suit","card game"],
  ["♥️","heart suit","card emotion game hearts"],
  ["♦️","diamond suit","card game"],
  ["♣️","club suit","card clubs game"],
  ["♟️","chess pawn","dupe expendable"],
  ["🃏","joker","card game wildcard"],
  ["🀄","mahjong red dragon","game"],
  ["🎴","flower playing cards","japanese card game"],
  ["🎭","performing arts","actor actress art entertainment mask theater theatre"],
  ["🖼️","framed picture","art frame museum painting"],
  ["🎨","artist palette","art artsy arty colorful creative entertainment museum"],
  ["🧵","thread","needle sewing spool string"],
  ["🪡","sewing needle","embroidery sew stitches sutures tailoring thread"],
  ["🧶","yarn","ball crochet knit"],
  ["🪢","knot","cord rope tangled tie twine twist"],
  ["💎","gem stone","diamond hands diamond engagement jewel money romance wedding"],
  ["🔇","muted speaker","mute quiet silent sound"],
  ["🔈","speaker low volume","soft sound"],
  ["🔉","speaker medium volume","sound"],
  ["🔊","speaker high volume","loud music sound"],
  ["📢","loudspeaker","address communication loud public sound"],
  ["📣","megaphone","cheering sound"],
  ["📯","postal horn","post"],
  ["🔔","bell","break church sound"],
  ["🔕","bell with slash","forbidden mute no not prohibited quiet silent"],
  ["🎼","musical score","music note"],
  ["🎵","musical note","music sound"],
  ["🎶","musical notes","music note sound"],
  ["🎙️","studio microphone","mic music"],
  ["🎚️","level slider","music"],
  ["🎛️","control knobs","music"],
  ["🎤","microphone","karaoke mic music sing sound"],
  ["🎧","headphone","earbud sound"],
  ["📻","radio","entertainment tbt video"],
  ["📱","mobile phone","cell communication telephone"],
  ["📲","mobile phone with arrow","build call cell communication receive telephone"],
  ["☎️","telephone","phone"],
  ["📞","telephone receiver","communication phone voip"],
  ["📟","pager","communication"],
  ["📠","fax machine","communication"],
  ["🔋","battery",""],
  ["🪫","low battery","drained electronic energy power"],
  ["🔌","electric plug","electricity"],
  ["💻","laptop","computer office pc personal"],
  ["🖥️","desktop computer","monitor"],
  ["🖨️","printer","computer"],
  ["⌨️","keyboard","computer"],
  ["🖱️","computer mouse",""],
  ["🖲️","trackball","computer"],
  ["💽","computer disk","minidisk optical"],
  ["💾","floppy disk","computer"],
  ["💿","optical disk","cd blu-ray computer dvd"],
  ["📀","dvd","blu-ray cd computer disk optical"],
  ["🧮","abacus","calculation calculator"],
  ["🪙","coin","dollar euro gold metal money rich silver"],
  ["💰","money bag","money rich bank bet billion cash cost dollar gold"],
  ["💴","yen banknote","bank bill currency money note"],
  ["💵","dollar banknote","bank bill currency money note"],
  ["💶","euro banknote","100 bank bill currency money note rich"],
  ["💷","pound banknote","bank bill billion cash currency money note"],
  ["💸","money with wings","bank banknote bill billion cash dollar fly"],
  ["💳","credit card","bank cash charge money pay"],
  ["🧾","receipt","accounting bookkeeping evidence invoice proof"],
  ["💹","chart increasing with yen","bank currency graph growth market money rise"],
  ["📈","chart increasing","pump up green data graph growth right trend up upward"],
  ["📉","chart decreasing","dump down red data down downward graph negative trend"],
  ["🔒","locked","closed lock private"],
  ["🔓","unlocked","cracked lock open unlock"],
  ["🔏","locked with pen","ink lock nib privacy"],
  ["🔐","locked with key","bike closed lock secure"],
  ["🔑","key","keys lock major password unlock"],
  ["🗝️","old key","clue lock"],
  ["🚬","cigarette","smoking"],
  ["⚰️","coffin","dead death vampire"],
  ["🪦","headstone","cemetery dead grave graveyard memorial rip tomb"],
  ["⚱️","funeral urn","ashes death"],
  ["🧿","nazar amulet","bead blue charm evil-eye talisman"],
  ["🪬","hamsa","fatima mary miriam amulet fortune guide hand"],
  ["🗿","moai","face moyai statue stoneface travel"],
  ["🪧","placard","card demonstration notice picket plaque protest sign"],
  ["🪪","identification card","id credentials document license security"],
  ["⚠️","warning","caution"],
  ["🚸","children crossing","child pedestrian traffic"],
  ["⛔","no entry","do fail forbidden not pass prohibited traffic"],
  ["🚫","prohibited","entry forbidden no not smoke"],
  ["🚳","no bicycles","bicycle bike forbidden not prohibited"],
  ["🚭","no smoking","forbidden not prohibited smoke"],
  ["🚯","no littering","forbidden litter not prohibited"],
  ["🚱","non-potable water","dry non-drinking prohibited"],
  ["🚷","no pedestrians","forbidden not pedestrian prohibited"],
  ["📵","no mobile phones","cell forbidden not phone prohibited telephone"],
  ["🔞","no one under eighteen","18 age forbidden not prohibited restriction underage"],
  ["☢️","radioactive","sign"],
  ["☣️","biohazard","sign"],
  ["💱","currency exchange","bank money"],
  ["💲","heavy dollar sign","billion cash charge currency million money pay"],
  ["⚕️","medical symbol","aesculapius medicine staff"],
  ["♻️","recycling symbol","recycle"],
  ["⚜️","fleur-de-lis","knights"],
  ["🔱","trident emblem","anchor poseidon ship tool"],
  ["📛","name badge",""],
  ["🔰","japanese symbol for beginner","chevron green leaf tool yellow"],
  ["⭕","hollow red circle","heavy large o"],
  ["✅","check mark button","checked checkmark complete completed done fixed tick"],
  ["☑️","check box with check","ballot checked done off tick"],
  ["✔️","check mark","checked checkmark done heavy tick"],
  ["❌","cross mark","cancel multiplication multiply x"],
  ["❎","cross mark button","multiplication multiply square x"],
  ["➰","curly loop","curl"],
  ["➿","double curly loop","curl"],
  ["〽️","part alternation mark",""],
  ["✳️","eight-spoked asterisk",""],
  ["✴️","eight-pointed star",""],
  ["❇️","sparkle",""],
  ["©️","copyright","c"],
  ["®️","registered","r"],
  ["™️","trade mark","tm trademark"],
  ["🔴","red circle","geometric"],
  ["🟠","orange circle",""],
  ["🟡","yellow circle",""],
  ["🟢","green circle",""],
  ["🔵","blue circle","geometric"],
  ["🟣","purple circle",""],
  ["🟤","brown circle",""],
  ["⚫","black circle","geometric"],
  ["⚪","white circle","geometric"],
  ["🟥","red square","card penalty"],
  ["🟧","orange square",""],
  ["🟨","yellow square","card penalty"],
  ["🟩","green square",""],
  ["🟦","blue square",""],
  ["🟪","purple square",""],
  ["🟫","brown square",""],
  ["⬛","black large square","geometric"],
  ["⬜","white large square","geometric"],
  ["◼️","black medium square","geometric"],
  ["◻️","white medium square","geometric"],
  ["◾","black medium-small square","geometric"],
  ["◽","white medium-small square","geometric"],
  ["▪️","black small square","geometric"],
  ["▫️","white small square","geometric"],
  ["🔶","large orange diamond","geometric"],
  ["🔷","large blue diamond","geometric"],
  ["🔸","small orange diamond","geometric"],
  ["🔹","small blue diamond","geometric"],
  ["🔺","red triangle pointed up","geometric"],
  ["🔻","red triangle pointed down","geometric"],
  ["💠","diamond with a dot","comic geometric"],
  ["🔘","radio button","geometric"],
  ["🔳","white square button","geometric outlined"],
  ["🔲","black square button","geometric"]
]

export default EMOJI_DATA
